<template>
    <div class="dynamics-wrap" v-if="status===1 && supportGroupBuying && showDynamics" v-show="show">
        <img :src="currentDynamics.img" class="dynamics-img" />
        <span class="dynamics-text">{{currentDynamics.text}}</span>
    </div>
</template>

<script>
    import { getGroupDynamicsP } from 'create-api';

    const HEAD_IMAGE_DEFAULT =
        'https://m.tuniucdn.com/fb2/t1/G1/M00/78/90/Cii9EVidLHOIflFrAAARPEd3gL8AAHaVgNy3rgAABFU217_w60_h60_c1_t0.png';
    export default {
        name: 'groupDynamics',
        props: {
            groupActivity: {
                type: Object,
                default: () => ({})
            },
            supportGroupBuying: {
                type: Boolean,
                default: false
            },
            status: {
                type: Number,
                default: 0
            }
        },

        data() {
            return {
                showDynamics: false,
                dynamicsList: [],
                currentDynamics: {},
                timer: null,
                show: false
            }
        },

        mounted() {
            this.supportGroupBuying && this.status === 1 && this.getGroupDynamics();
        },

        beforeDestroy() {
            clearTimeout(this.timer);
        },

        methods: {
            async getGroupDynamics() {
                let res = await getGroupDynamicsP({
                    activityId: this.groupActivity.retailPsId,
                    limit: 20
                })
                if (res && res.success && res.data && res.data.list && res.data.list.length > 0) {
                    this.showDynamics = true;
                    this.dynamicsList = res.data.list.map(val => {
                        let showNick = val.userNick.length > 4 ? `${val.userNick.substring(0, 4)}...` : val
                            .userNick;
                        let img = val.userHeadImg || HEAD_IMAGE_DEFAULT;
                        if (!img.includes('https')) {
                            img = img.replace('http', 'https');
                        }
                        return {
                            img,
                            text: showNick + val.description
                        }
                    });
                    this.changeDynamics();
                } else {
                    this.showDynamics = false;
                }
            },

            changeDynamics() {
                let index = 0;
                let self = this;

                function change() {
                    self.currentDynamics = self.dynamicsList[index % self.dynamicsList.length];
                    self.show = true;
                    index++;
                    self.timer = setTimeout(() => {
                        self.show = false;
                        self.timer = setTimeout(change, 3000);
                    }, 2000);
                }
                if (this.dynamicsList.length > 0) {
                    change();
                }
            }
        }


    }

</script>

<style lang="scss">
    .dynamics-wrap {
        position: absolute;
        top: 9px;
        left: 10px;
        height: 30px;
        background: #000;
        opacity: 0.5;
        border-radius: 15px;
        display: flex;
        align-items: center;

        .dynamics-img {
            width: 20px;
            height: 20px;
            border-radius: 10px;
            margin-left: 6px;
        }

        .dynamics-text {
            margin-left: 7px;
            margin-right: 11px;
            height: 14px;
            line-height: 14px;
            font-size: 12px;
            color: #fff;
        }
    }

</style>



// WEBPACK FOOTER //
// groupDynamics.vue